module.exports = __webpack_public_path__ + "static/Robeson-Community-Center-590-W-5th-St-Lumberton-NC-28358-ENG-a8b2a5f2c446d5bb3cd6116970ebd88e.jpeg";